import RessourceReducerFactory from 'helpers/RessourceReducerFactoryHelpers';
import RessourceSelectorsFactory from 'helpers/RessourceSelectorsFactoryHelpers';
import {
    default as createActionCreator,
    HTTP_METHODS,
} from 'helpers/RessourceActionCreatorsFactoryHelpers';

/*
 * Configuration
 */
export const ressourceName = 'USER';
export const ressourceNamePlural = 'USERS';

/*
 * Actions
 */

export const REQUEST_GET_USERS = `REQUEST_GET_${ressourceNamePlural}`;
export const REQUEST_GET_USERS_SUCCESS = `REQUEST_GET_${ressourceNamePlural}_SUCCESS`;
export const REQUEST_GET_USERS_ERROR = `REQUEST_GET_${ressourceNamePlural}_ERROR`;

export const REQUEST_GET_USER = `REQUEST_GET_${ressourceName}`;
export const REQUEST_GET_USER_SUCCESS = `REQUEST_GET_${ressourceName}_SUCCESS`;
export const REQUEST_GET_USER_ERROR = `REQUEST_GET_${ressourceName}_ERROR`;

export const REQUEST_POST_USER = `REQUEST_POST_${ressourceName}`;
export const REQUEST_POST_USER_SUCCESS = `REQUEST_POST_${ressourceName}_SUCCESS`;
export const REQUEST_POST_USER_ERROR = `REQUEST_POST_${ressourceName}_ERROR`;

export const REQUEST_PUT_USER = `REQUEST_PUT_${ressourceName}`;
export const REQUEST_PUT_USER_SUCCESS = `REQUEST_PUT_${ressourceName}_SUCCESS`;
export const REQUEST_PUT_USER_ERROR = `REQUEST_PUT_${ressourceName}_ERROR`;

export const REQUEST_DELETE_USER = `REQUEST_DELETE_${ressourceName}`;
export const REQUEST_DELETE_USER_SUCCESS = `REQUEST_DELETE_${ressourceName}_SUCCESS`;
export const REQUEST_DELETE_USER_ERROR = `REQUEST_DELETE_${ressourceName}_ERROR`;

export const SET_USERS_PAGE = `SET_${ressourceNamePlural}_PAGE`;
export const SET_USERS_PAGE_SIZE = `SET_${ressourceNamePlural}_PAGE_SIZE`;
export const FLUSH_USERS = `FLUSH_${ressourceNamePlural}`;

/*
 * Reducer
 */

export const APIUsersReducer = RessourceReducerFactory({
    ressourceName,
    ressourceNamePlural,
});

/*
 * Action Creators
 */

export const getUsers = createActionCreator({
    type: REQUEST_GET_USERS,
    method: HTTP_METHODS.GET,
    url: '/users',
    withPagination: true,
});

export const getUser = createActionCreator({
    type: REQUEST_GET_USER,
    method: HTTP_METHODS.GET,
    url: '/users/:id',
    withPagination: false,
});

export const postUser = createActionCreator({
    type: REQUEST_POST_USER,
    method: HTTP_METHODS.POST,
    url: '/users',
    withPagination: false,
});

export const putUser = createActionCreator({
    type: REQUEST_PUT_USER,
    method: HTTP_METHODS.PUT,
    url: '/users/:id',
    withPagination: false,
});

export const deleteUser = createActionCreator({
    type: REQUEST_DELETE_USER,
    method: HTTP_METHODS.DELETE,
    url: '/users/:id',
    withPagination: false,
});

/**
 * Create a SET_USERS_PAGE action
 * @param {integer} page The page to set
 */
export function setUsersPage(page) {
    return {
        type: SET_USERS_PAGE,
        payload: {
            page,
        },
    };
}

/**
 * Create a SET_USERS_PAGE_SIZE action
 * @param {integer} pageSize The page size
 */
export function setUsersPageSize(pageSize) {
    return {
        type: SET_USERS_PAGE_SIZE,
        payload: {
            pageSize,
        },
    };
}

/**
 * Create a FLUSH_USERS action
 */
export function flushUsers() {
    return {
        type: FLUSH_USERS,
    };
}

/*
 * Selectors
 */
export const {
    getItemSelector,
    getItemsSelector,
    isLoadingSelector,
    getCountSelector,
    getPageSelector,
    getPageSizeSelector,
    getCurrentItemsSelector,
} = RessourceSelectorsFactory({
    reducerName: 'APIUsers',
});
